"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFileSystem = exports.TERMINAL_ROOT_DIR = exports.ACCESS_DENIED_FUNCTION = exports.DEFAULT_FILE_SYSTEM = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importStar(require("react"));
const hooks_1 = require("../../hooks");
const types_1 = require("./types");
const utils_1 = require("./utils");
exports.DEFAULT_FILE_SYSTEM = [
    {
        name: 'home',
        items: [],
    },
    {
        name: 'usr',
        items: [],
    },
];
const ACCESS_DENIED_FUNCTION = ({ sendToStdout, }) => __awaiter(void 0, void 0, void 0, function* () {
    sendToStdout({ message: 'Access Denied.', type: types_1.TerminalMessageType.Error });
});
exports.ACCESS_DENIED_FUNCTION = ACCESS_DENIED_FUNCTION;
exports.TERMINAL_ROOT_DIR = '/';
function mapParentDirectories(dir, parentDir) {
    const newDir = Object.assign(Object.assign({}, dir), { func: (dir === null || dir === void 0 ? void 0 : dir.isLocked)
            ? exports.ACCESS_DENIED_FUNCTION
            : ({ changeDirectory }) => {
                changeDirectory(dir);
            }, parent: parentDir });
    newDir.items = newDir.items.map((item) => {
        if (!(0, types_1.isFileSystemDirectory)(item))
            return item;
        return mapParentDirectories(item, newDir);
    });
    return newDir;
}
function useFileSystem({ rootDirItems, homeDirPath = exports.TERMINAL_ROOT_DIR, }) {
    const { primaryColor } = (0, hooks_1.usePrimaryColor)();
    const rootDir = (0, react_2.useMemo)(() => {
        return mapParentDirectories({
            name: exports.TERMINAL_ROOT_DIR,
            items: rootDirItems !== null && rootDirItems !== void 0 ? rootDirItems : exports.DEFAULT_FILE_SYSTEM,
        });
    }, [rootDirItems]);
    const homeDir = (0, react_2.useMemo)(() => {
        const dir = (0, utils_1.resolveFilepath)(homeDirPath, rootDir, rootDir);
        return (0, types_1.isFileSystemDirectory)(dir) ? dir : rootDir;
    }, [rootDir, homeDirPath]);
    const [currentDirectory, setCurrentDirectory] = (0, react_2.useState)(homeDir);
    const currentDirRef = (0, react_2.useRef)(currentDirectory);
    currentDirRef.current = currentDirectory;
    const resolvePath = (0, react_2.useCallback)((path) => {
        return (0, utils_1.resolveFilepath)(path, currentDirRef.current, rootDir)[0];
    }, [rootDir]);
    const handleChangeDirectory = (0, react_2.useCallback)(({ sendToStdout }, args) => {
        if (!args[0]) {
            setCurrentDirectory(homeDir);
            return;
        }
        const dir = resolvePath(args[0]);
        if (!dir) {
            sendToStdout({
                message: `${args.join()} not found`,
                type: types_1.TerminalMessageType.Error,
            });
            return;
        }
        if (!(0, types_1.isFileSystemDirectory)(dir)) {
            sendToStdout({
                message: `${args.join()} is not a directory`,
                type: types_1.TerminalMessageType.Error,
            });
            return;
        }
        if (dir.isLocked) {
            sendToStdout({
                message: 'Access Denied.',
                type: types_1.TerminalMessageType.Error,
            });
            return;
        }
        setCurrentDirectory(dir);
    }, [resolvePath, homeDir]);
    const changeDirectoryCommand = (0, react_2.useMemo)(() => {
        return {
            name: 'cd',
            helpText: 'cd - Change terminal directory - cd <path name>',
            func: handleChangeDirectory,
        };
    }, [handleChangeDirectory]);
    const handleList = (0, react_2.useCallback)(({ sendToStdout }) => {
        sendToStdout({
            message: (react_2.default.createElement(react_2.default.Fragment, null, currentDirRef.current.items.map((item, index) => (react_2.default.createElement(react_1.Box, { as: "span", key: index, mr: 1, fontWeight: (0, types_1.isFileSystemDirectory)(item) ? primaryColor : undefined, color: (0, types_1.isFileSystemDirectory)(item) ? primaryColor : undefined }, item.name))))),
        });
    }, [primaryColor]);
    const listCommand = (0, react_2.useMemo)(() => {
        return {
            name: 'ls',
            func: handleList,
            helpText: 'ls - List folders and files in the current directory',
        };
    }, [handleList]);
    const handleWorkingDir = (0, react_2.useCallback)(({ sendToStdout }) => {
        sendToStdout((0, utils_1.getFullDirectoryPath)(currentDirRef.current));
    }, []);
    const workingDirCommand = (0, react_2.useMemo)(() => {
        return {
            name: 'pwd',
            func: handleWorkingDir,
        };
    }, [handleWorkingDir]);
    const lessCommand = (0, react_2.useMemo)(() => {
        return {
            name: 'less',
            helpText: 'less - Read text files - less <filepath>',
            func: (context, args) => __awaiter(this, void 0, void 0, function* () {
                const { sendToStdout } = context;
                const filePath = args[0];
                if (!filePath) {
                    sendToStdout({
                        message: 'No filepath passed',
                        type: types_1.TerminalMessageType.Error,
                    });
                    return;
                }
                const file = resolvePath(filePath);
                if (!file) {
                    sendToStdout({
                        message: `File not found at ${filePath}`,
                        type: types_1.TerminalMessageType.Error,
                    });
                    return;
                }
                if ((0, types_1.isFileSystemDirectory)(file)) {
                    sendToStdout({
                        message: `${filePath} is a directory`,
                        type: types_1.TerminalMessageType.Error,
                    });
                    return;
                }
                if (!file.name.endsWith('.txt')) {
                    sendToStdout({
                        message: `${filePath} is not a txt file`,
                        type: types_1.TerminalMessageType.Error,
                    });
                    return;
                }
                yield file.func(context, []);
            }),
        };
    }, [resolvePath]);
    const commands = (0, react_2.useMemo)(() => {
        const currentDirectoryCommands = currentDirectory.items.filter(types_1.isTerminalCommand);
        return [
            changeDirectoryCommand,
            listCommand,
            workingDirCommand,
            lessCommand,
            ...currentDirectoryCommands,
        ];
    }, [
        lessCommand,
        currentDirectory,
        changeDirectoryCommand,
        listCommand,
        workingDirCommand,
    ]);
    return {
        currentDirectory,
        commands,
        resolvePath,
        rootDirectory: rootDir,
        changeDirectory: setCurrentDirectory,
    };
}
exports.useFileSystem = useFileSystem;
//# sourceMappingURL=useFileSystem.js.map